// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useState} from 'react';
import etask from 'zetask';
import {Button, t_button_color} from '../button';
import {Modal} from '../../../hola/pub/lib/modal';
import cn from 'classnames';

import styles from './dialogs.module.less';

interface i_confirm_dialog_props {
    on_confirm: ()=>void;
    on_cancel?: ()=>void;
    close: ()=>void;
    is_open: boolean;
    hero_img?: React.ReactNode;
    title: string;
    sub_title?: React.ReactNode;
    caption_cancel: React.ReactNode;
    cancel_color?: t_button_color;
    confirm_color?: t_button_color;
    caption_confirm: React.ReactNode;
    loader?: React.ReactNode;
    width?: number;
    buttons_full_width?: boolean;
}
export const Confirmation_dialog = (props: i_confirm_dialog_props)=>{
    const [is_busy, set_is_busy] = useState(false);
    const confirm = ()=>etask(function*(){
        set_is_busy(true);
        yield props.on_confirm();
        set_is_busy(false);
    });
    return <Modal lighter_close_btn={true} is_open={props.is_open} paddingless
      width={props.width} on_close={props.close} cls={styles.modal}
      portal={true}
      on_overlay_click={ev=>{
        props.close();
        ev.stopPropagation();
      }}>
      <div className={styles.confirm_modal}>
        {props.hero_img &&
          <div className={styles.hero_img}>{props.hero_img}</div>}
        <div>
          <p className={styles.title}>{props.title}</p>
          {props.sub_title &&
            <p className={styles.sub_title}>{props.sub_title}</p>}
        </div>
        <div className={cn(styles.btn_container,
          props.buttons_full_width && styles.full_width)}>
          <Button caption={props.caption_cancel}
            color={props.cancel_color ?? 'secondary'}
            on_click={()=>{
              props.on_cancel?.();
              props.close();
            }}/>
          <Button caption={is_busy && props.loader || props.caption_confirm}
            color={props.confirm_color ?? 'primary'} on_click={confirm}/>
        </div>
      </div>
    </Modal>;
};
